/* eslint-disable */
import axios from 'axios'
import * as vars from '@/vars.json'

const httpAxios = axios.create({
  params: {},
})

export const referrals = {
  namespaced: true,
  state: {
    coupons: [],
    referralsOwnerCode: '',
  },

  mutations: {

    getAllCoupons: (state, data) => {
      state.coupons = data;
    },
    getAvailableCoupons: (state, data) => {
      state.coupons = data;
    },
    SET_REFERRAL_OWNERCODE: (state, data) => {
      state.referralsOwnerCode = data;
    },

  },
  actions: {
    codeGenerator({ rootState }) {
      const userId = rootState.users.user.uid;
      // console.log(userId);
      return new Promise((resolve, reject) => {
        httpAxios.post(vars.url + '/getReferralCode', { id: userId }).then((response) => {
          resolve(response.data)
        }).catch((error) => {
          reject(error)
        });
      });
    },
    codeValidator({ commit }, referralData) {
      return new Promise((resolve, reject) => {
        httpAxios.post(vars.url + '/validateReferralCode', { referralData: referralData }).then((response) => {
          resolve(response.data)
        }).catch((error) => {
          reject(error)
        })
      })
    },
    getCodeOfReferralOwner({ commit }, ownerCodeId) {
      return new Promise((resolve, reject) => {
        httpAxios.post(vars.url + '/getCodeOfReferralOwner', {ownerCodeId: ownerCodeId}).then((response) => {
          resolve(response.data)
        }).catch((error) => {
          reject(error)
        })
      })
    },
    getReferralsListAndAmount({ commit }, userId) {
      return new Promise((resolve, reject) => {
        httpAxios.post(vars.url + '/getReferralsListAndAmount', { id: userId }).then((response) => {
          resolve(response.data)
        }).catch((error) => {
          reject(error)
        })
      })
    },
    getAllCoupons({ commit, rootState }) {
      const userId = rootState.users.user.uid;
      // console.log(userId);
      return new Promise((resolve, reject) => {
        httpAxios.post(vars.url + '/getCoupons', { uid: userId }).then((response) => {
          commit('getAllCoupons', response.data);
          resolve(response.data);
        }).catch((error) => {
          reject(error)
        })
      })
    },
    getAvailableCoupons({ commit, rootState }) {
      const userId = rootState.users.user.uid;
      return new Promise((resolve, reject) => {
        httpAxios.post(vars.url + '/getCoupons', { uid: userId }).then((response) => {
          var coupons = [];
          for (var coupon in response.data) coupons.push(response.data[coupon]);
          coupons = coupons.filter(coupon => coupon.used !== true);
          commit('getAvailableCoupons', coupons);
          resolve(response.data);
        }).catch((error) => {
          reject(error)
        })
      })
      },
      sendWithdrawRequest ({ commit }, withdrawData) {
        return new Promise((resolve, reject) => {
          httpAxios.post(vars.url + '/sendWithdrawRequest',{data: withdrawData}).then((response) => {
            resolve(response.data)
          }).catch((error) => {
            reject(error)
          })
        })
      },
      getWithdrawRequests ({ commit }, withdrawData) {
        return new Promise((resolve, reject) => {
          httpAxios.post(vars.url + '/getWithdrawRequests',{withdrawData: withdrawData}).then((response) => {
            resolve(response.data)
          }).catch((error) => {
            reject(error)
          })
        })
      },
      getWithdrawRequestsAdmin ({ commit }) {
        return new Promise((resolve, reject) => {
          httpAxios.post(vars.url + '/getWithdrawRequestsAdmin').then((response) => {
            resolve(response.data)
          }).catch((error) => {
            reject(error)
          })
        })
      },
      aceptCancelWithdrawRequestsAdmin ({ commit }, withdrawData) {
        return new Promise((resolve, reject) => {
          httpAxios.post(vars.url + '/aceptCancelWithdrawRequestsAdmin',{withdrawData: withdrawData}).then((response) => {
            resolve(response.data)
          }).catch((error) => {
            reject(error)
          })
        })
      },
      getClientsWithReferrals ({ commit }) {
        return new Promise((resolve, reject) => {
          httpAxios.post(vars.url + '/getClientsWithReferrals').then((response) => {
            resolve(response.data)
          }).catch((error) => {
            reject(error)
          })
        })
      },
      probarpagos ({ commit }) {
        return new Promise((resolve, reject) => {
          httpAxios.post(vars.url + '/addCommissionToReferralLog').then((response) => {
            resolve(response.data)
          }).catch((error) => {
            reject(error)
          })
        })
      },
      getUserByEmail ({ commit }, email) {
        return new Promise(async (resolve, reject) => {
          httpAxios.post(vars.url + '/getClientByEmail', {email: email}).then((response) => {
            resolve(response.data)
          }).catch((error) => {
            reject(error)
          })
        })
      },
      enableDisableClient ({ commit }, data) {
        return new Promise((resolve, reject) => {
          httpAxios.post(vars.url + '/enableDisableClient', {data: data}).then((response) => {
            resolve(response.data)
          }).catch((error) => {
            reject(error)
          })
        })
      },
  },
  getters: {
    getCoupons(state) {
      return state.coupons
    }
  }
}
